export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-elevator-5cee4caf38bbc0b0337d8779e48c063e.svg";